import { render, staticRenderFns } from "./addInvhistDetail.vue?vue&type=template&id=e61adf50&scoped=true&"
import script from "./addInvhistDetail.vue?vue&type=script&lang=js&"
export * from "./addInvhistDetail.vue?vue&type=script&lang=js&"
import style0 from "./addInvhistDetail.vue?vue&type=style&index=0&id=e61adf50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61adf50",
  null
  
)

export default component.exports